const createMemberPinToast = (state = null, action) => {
  if (action.type === "SET_CREATE_MEMBER_PIN_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CREATE_MEMBER_PIN_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default createMemberPinToast;
